import Axios from "axios";
import qs from "qs";

export interface PaginatableResource {
  take?: number;
  skip?: number;
}

export interface IGetProfileParams extends PaginatableResource {
  query?: string;
  industries?: string[];
  softSkills?: string[];
  hardSkills?: string[];
}

const TOKEN_IDENTIFIER = "com.almond.portal.auth.token";
const token: string | null = localStorage.getItem(TOKEN_IDENTIFIER);

const v1 = Axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

v1.interceptors.response.use(
  (config: any) => config,
  (error: any) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem(TOKEN_IDENTIFIER);
      window.location.reload();
      return;
    }

    return Promise.reject(error);
  }
);

class API {
  private getParams(params: any) {
    const skip = params?.skip || 0;
    const take = params?.take || 30;

    return {
      ...params,
      skip,
      take,
    };
  }

  public setToken(incomingToken: string | null) {
    v1.defaults.headers = {
      Authorization: `Bearer ${incomingToken}`,
    } as any;
  }

  public async getUser() {
    return await v1.get("/me");
  }
  
  public async logout() {
    return await v1.post("/logout");
  }

  public async getTotalSettlementAmount(duration: string) {
    return await v1.get(`/total-settlement-amt/?durationFilter=${duration}`);
  }

  public async getSettlements(page?: number, size?: number, params?: any) {
    return await v1.get(
      `/settlements?page=${page || 0}&size=${size || 10}${
        params ? "&" + qs.stringify(params, { allowDots: true }) : ""
      }`
    );
  }

  public async createSettlement(settlement: any) {
    return await v1.post(`/settlements`, settlement);
  }

  public async updateSettlement(settlementId: string, data: any) {
    return await v1.put(`/settlements/${settlementId}`, data);
  }

  public async deletSettlement(settlementId?: string) {
    return await v1.delete(`/settlements/${settlementId}`);
  }
}

export const Api = new API();
